import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ef433d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "msg_center_wrap" }
const _hoisted_2 = { class: "msg_center_menu" }
const _hoisted_3 = { class: "msg_center_item" }
const _hoisted_4 = { class: "msg_center_tbody" }
const _hoisted_5 = { class: "mod_wrap mod_set_wrap" }
const _hoisted_6 = { class: "mod_c" }
const _hoisted_7 = { class: "mod_c_title" }
const _hoisted_8 = { class: "mod_c_tbody" }

import { computed, ref, shallowRef } from 'vue';
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { Menu } from 'ant-design-vue';
import Crumb from '@/components/Crumb.vue';
import Basic from './Basic.vue';
import Security from './Security.vue';
import Certification from './Certification/index.vue';
import { MenuType } from '../customServe/types';
import http from '@/api';
import { useHomeStore } from '@/pinia/home';


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalSet',
  setup(__props) {

const aMenu = Menu;
const aMenuItem = Menu.Item;
const store = useStore();
const route = useRoute();
const router = useRouter();
// 根据header项过滤菜单
const selectedKeys = ref<string[]>([]);
const menuList = shallowRef<MenuType[]>([]);

const baseMenu: Array<MenuType> = [
  {
    name: 'Basic',
    title: '基本设置',
    path: '/personal/set/base',
    component: Basic,
  },
  {
    name: 'Security',
    title: '安全设置',
    path: '/personal/set/security',
    component: Security,
  },
  {
    name: 'Certification',
    title: '实名认证',
    path: '/personal/set/certification',
    component: Certification,
  },
];
const urlPush = (e: any) => {
  router.push(e.key);
};

const homeStore = useHomeStore();
const init = () => {
  menuList.value = !homeStore.funcData['Certification'] ? baseMenu.filter((e) => e.name !== 'Certification') : baseMenu;
  if (!route.params.name) {
    selectedKeys.value = [menuList.value[0].path];
    return;
  }
  const res = menuList.value.some((e) => e.path === route.path);
  if (!res) {
    router.push('/404');
    return;
  }
  selectedKeys.value = [route.path];
};
init();
const activedKey = computed(() => menuList.value.findIndex((e) => e.path === selectedKeys.value[0]));
const viewTitle = computed(() => (selectedKeys.value.length > 0 ? menuList.value[activedKey.value].title : route.meta?.title));
/**
 * init 初始化
 * 路由进入前处理底部栏
 **/
store.commit('home/setCustomFooter', true);
const customData = computed(() => store.state.home.customData);
const customFootStyle = computed(() => store.state.home.customFootStyle);
onBeforeRouteUpdate((to) => {
  selectedKeys.value = [to.path];
});
onBeforeRouteLeave(() => {
  store.commit('home/setCustomFooter', false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(route).meta?.title), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), (item) => {
        return (_openBlock(), _createBlock(_unref(aMenu), {
          class: "msg_center_menu_main",
          theme: "light",
          mode: "inline",
          inlineIndent: 18,
          selectedKeys: selectedKeys.value,
          "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
          key: item.path,
          onClick: urlPush
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_unref(aMenuItem), {
              key: item.path
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1024))
          ]),
          _: 2
        }, 1032, ["selectedKeys"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Crumb),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(viewTitle)), 1),
          _createElementVNode("div", _hoisted_8, [
            (selectedKeys.value.length > 0)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(menuList)[_unref(activedKey)].component), { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", { class: "mod_footer" }, _toDisplayString(_unref(customData).copyright), 513), [
        [_vShow, _unref(customFootStyle)]
      ])
    ])
  ]))
}
}

})